// Angular Imports
import { Component, OnInit, Input, Injector } from '@angular/core';

// Component imports
import { MPSearchBaseComponent } from '../_base/mp-base-search.component';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { SearchService } from '../_services/data-services/search.service';

// Model imports
import { SearchParametersDto } from '../_models/search-parameters-dto';
import { VendorDisbursementSearchResultDto } from '../_models/vendor-disbursement-search-result-dto';
import { APPaymentParameterDto } from '../../cirabooks/shared-cirabooks-module/_models/accounts-payable/ap-payment/ap-payment-parameter-dto';

@Component({
    selector: 'app-search-vendor-disbursements-check',
    templateUrl: './search-vendor-disbursements-check.component.html',
    styleUrls: ['./search-vendor-disbursements-check.component.scss']
})
export class SearchVendorDisbursementsCheckComponent extends MPSearchBaseComponent implements OnInit {
    @Input() communityId: number;

    vendorDisbursements: VendorDisbursementSearchResultDto[] = [];
    showPaymentDetail = false;
    apPaymentDetailParam: APPaymentParameterDto;

    constructor(
        protected readonly injector: Injector,
        private readonly errorService: ServerErrorService,
        private readonly searchService: SearchService
    ) {
        super(injector);
    }

    ngOnInit() {
        if (!!this.searchText) {
            this.searchVendorDisbursementsCheck();
        }
    }

    onCheckClick(data: VendorDisbursementSearchResultDto): void {
        this.apPaymentDetailParam = new APPaymentParameterDto();
        this.apPaymentDetailParam.communityId = data.communityId;
        this.apPaymentDetailParam.paymentId = data.paymentId;
        this.apPaymentDetailParam.managementCompanyId = data.managementCompanyId;
        this.apPaymentDetailParam.clearCache = true;
        this.showPaymentDetail = true;
    }

    public searchVendorDisbursementsCheck() {
        const param: SearchParametersDto = new SearchParametersDto();
        param.clearCache = true;
        param.searchText = this.searchText;
        param.communityId = this.communityId;
        this.vendorDisbursements = [];
        this.loadingVisible = true;
        this.searchService.searchVendorDisbursements(param).subscribe(
            (data) => {
                this.vendorDisbursements = data;
                this.loadingVisible = false;
                this.updateGridSearchStatus(data);
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
